import { render, staticRenderFns } from "./communicationDashboardPopupsNew.vue?vue&type=template&id=42b8d652&scoped=true"
import script from "./communicationDashboardPopupsNew.vue?vue&type=script&lang=js"
export * from "./communicationDashboardPopupsNew.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardPopupsNew.vue?vue&type=style&index=0&id=42b8d652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b8d652",
  null
  
)

export default component.exports